import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
} from '../../interfaces/apiInterfaces';

export class ImportLocalCompanyCommand extends IRequestCommand<
  IImportLocalCompanyResponse,
  ErrorDetails,
  FormData
> {

  public override setParameters(formData: FormData) {
    this._commandType = CommandRequestType.POST;
    this._commandUrl = `carrier/${formData.get('carrier')}/import`;
    this._commandBody = formData;
  }
}

export interface IImportLocalCompanyResponse extends ICommandResponse {
  successLines: number,
  newClients: number,
  updateClients: number,
  errors: Array<IImportCSVError>,
  warnings: Array<IImportCSVError>
}

export interface IImportCSVError {
  warning: string,
  error: string,
  lineNumber: number,
  line: Object
}
